import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../../auth/AuthContext";
import { mustCompleteOnboarding } from "../../auth/onboarding";
import {
  TRIAL_PRODUCT_PARAM,
  rememberTrialProduct,
} from "../../constants/trialProduct";

export default function AuthSuccess(){
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { refreshUser } = useAuth();
    const [error, setError] = useState(false);

    useEffect(() => {
        const run = async () => {
            // O backend passou a enviar os dados sensíveis (token, etc.) no
            // fragmento da URL (#token=...) em vez da query string, pois o
            // fragmento não é enviado ao servidor nem vaza em logs/Referer.
            // Lemos preferencialmente do hash; mantemos fallback à query para
            // compatibilidade durante a transição (token legado em ?token=).
            const hashParams = new URLSearchParams(
                window.location.hash.startsWith("#")
                    ? window.location.hash.slice(1)
                    : window.location.hash
            );

            const read = (key) => hashParams.get(key) ?? searchParams.get(key);

            const token = read("token");
            const id = read("id");
            const email = read("email");
            const tenantId = read("tenantId");
            const produto = read(TRIAL_PRODUCT_PARAM);

            if(token) {
                localStorage.setItem("token", token);
                localStorage.setItem("user", JSON.stringify({
                    id,
                    email,
                    tenantId: tenantId || null
                }));

                // O produto escolhido no site (agendamento | atendimento) veio
                // junto no fragmento e só será consumido no submit do
                // onboarding, algumas telas adiante. Guardamos em
                // `sessionStorage` — não é chave de sessão (INV-F2), é a
                // lembrança de um clique de marketing, e morre com a aba.
                rememberTrialProduct(produto);

                // Limpa o fragmento (e a query) da URL para que o token não
                // fique visível na barra de endereço nem no histórico.
                window.history.replaceState(null, "", window.location.pathname);

                // Usamos o RETORNO de `refreshUser()`, não o `user` do
                // contexto: o `setUser` só se reflete no próximo render, e o
                // `navigate` abaixo acontece ainda neste tick — ler o contexto
                // aqui daria o usuário anterior (normalmente `null`) e mandaria
                // todo mundo para o mesmo lugar.
                const profile = await refreshUser();

                // Quem entra por "Continuar com Google" recebe um `User` e
                // NENHUM `Tenant`. Sem esta ramificação ele caía em
                // `/visao-geral` e via uma tela vazia, sem erro e sem saída.
                //
                // ⚠️ `mustCompleteOnboarding` (não tem `tenant`), NÃO
                // `needsOnboarding` (não tem `tenant.segment`) — mesma regra do
                // `ProtectedRoute`. Quem já tem tenant e só não escolheu o
                // segmento (o estado normal do signup por e-mail/senha) usa o
                // produto normalmente: entra na `/visao-geral` e vê o BANNER do
                // `AppLayout`. Desviá-lo para o onboarding seria pousá-lo numa
                // tela que a guarda nem o obrigaria a ficar.
                //
                // Regra geral: `needsOnboarding` alimenta banner e modal;
                // nunca `navigate` nem `<Navigate>`.
                if (mustCompleteOnboarding(profile)) {
                    navigate("/onboarding", { replace: true });
                } else {
                    navigate("/visao-geral", { replace: true });
                }
            }else{
                setError(true);
                // `/auth` NÃO existe no roteador (só `/auth-success`): o ramo de
                // erro caía no catch-all 404 e o usuário via "página não
                // encontrada" em vez da tela de login. Corrigido em 21/08/2026.
                navigate("/login", { replace: true });
            }
        };
        run();
    }, [searchParams, navigate, refreshUser]);

    if (error) {
        return <div>Não foi possível concluir o login. Redirecionando...</div>;
    }
    return <div>Processando login...</div>;
}
